module.exports = "/images/side-users-active.svg?5dc56569cb533d9daa822474048f32f1";